export const MAX_HAND_SIZE = 8;
export const MAX_GROWTH_MINDSET = 5;
export const STATIC_ROOT = process.env.PUBLIC_URL;
export const MAX_TURN_COUNT = 48;
export const GAME_NAME = "SomeGame"
export const AREA_TYPE = {
  Opportunities: "Opportunities",
  Hand: "Hand",
  Deck: "Deck",
  DiscardPile: "Discard Pile",
};
export const TERMINAL_STATE = {
  Win: "win",
  FixedMindset: "fixed-mindset",
  FailedExam: "failed-exam",
}
